import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { buildFirearmPath } from "../utils/firearmLink";

const ToolbarBox = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(0.25),
  paddingRight: theme.spacing(0.5),
}));

const iconBtnSx = { padding: 0.5 };

function ResultToolbar({ result }) {
  const href = buildFirearmPath(result);
  return (
    <ToolbarBox onClick={(e) => e.stopPropagation()}>
      <Tooltip title="Open in new tab" placement="left">
        <IconButton
          size="small"
          component="a"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          sx={iconBtnSx}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </ToolbarBox>
  );
}

ResultToolbar.propTypes = {
  result: PropTypes.object,
};

export default ResultToolbar;
